import React, { useEffect, useRef } from "react";
import { gsap } from "./../../lib/index";

export default function SubHero() {
    const sectionRef = useRef(null);
    const headingRef = useRef(null);
    const textRef = useRef(null);
    const btnWrapperRef = useRef(null);
    const videoRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        const heading = headingRef.current;
        const text = textRef.current;
        const buttonWrapper = btnWrapperRef.current;
        const video = videoRef.current;
        const content = contentRef.current;

        // Animation for heading
        if (heading) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: heading,
                    start: "top 90%",
                    end: "top 60%",
                    once: true,
                },
            }).from(heading, { y: 30, opacity: 1, duration: 0.7, ease: "power2.out" });
        }

        // Animation for text content
        if (text) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: "top 90%",
                    end: "top 60%",
                    once: true,
                },
            }).from(text, { y: 30, opacity: 1, duration: 0.7, delay: 0.2, ease: "power2.out" });
        }

        // Animation for button
        if (buttonWrapper) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: buttonWrapper,
                    start: "top 90%",
                    end: "top 60%",
                    once: true,
                },
            }).from(buttonWrapper, { y: 30, opacity: 1, duration: 0.7, delay: 0.4, ease: "power2.out" });
        }

        // Animation for video
        if (video) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: video,
                    start: "top 90%",
                    end: "top 60%",
                    once: true,
                },
            }).from(video, { scale: 1, opacity: 1, duration: 0.9, ease: "power2.out" });
        }

        // Mobile adjustments
        const handleResize = () => {
            if (content) {
                if (window.innerWidth <= 768) {
                    // Mobile adjustments if needed
                } else {
                    // Desktop adjustments if needed
                }
            }
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    return (
        <section 
            ref={sectionRef} 
            className="relative min-h-screen py-16 md:py-24 px-4 md:px-8 bg-white overflow-hidden"
        >
            <div 
                ref={contentRef}
                className="container mx-auto relative h-full"
            >
                {/* Video as background */}
                <div 
                    className="w-full h-full rounded-xl overflow-hidden shadow-xl relative"
                >
                    <div 
                        ref={videoRef} 
                        className="relative w-full h-full"
                    >
                        <video 
                            className="w-full h-auto object-cover" 
                            autoPlay 
                            loop 
                            muted 
                            playsInline
                            style={{ minHeight: '500px' }}
                        >
                            <source src="/FuteurPromo.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        
                        {/* Semi-transparent gradient overlay for better text visibility */}
                        <div className="absolute inset-0 bg-gradient-to-r from-black via-black to-transparent opacity-45"></div>
                    </div>
                </div>
                
                {/* Text Content overlay */}
                <div className="absolute top-0 left-0 p-10 md:p-20 max-w-xl z-10 bg-gradient-to-r from-black to-transparent bg-opacity-60 backdrop-blur-[2px] h-full flex flex-col justify-center rounded-l-xl w-full md:w-[45%] lg:w-[40%]">
                    <h2 
                        ref={headingRef}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6  "
                    >
                        FuteurCred <br />
                       
                    </h2>
                    <p 
                        ref={textRef}
                        className="text-lg text-white mb-8 drop-shadow-lg font-medium"
                    >
                        FuteurCred is a mobile app that helps monitor your business credit score from credit bureaus like Experian to improve your credit health. <br/>
                        <br/>
                        Available on the App Store and Google Play.
                    </p>
                    <div 
                        ref={btnWrapperRef}
                        className="mt-4"
                    >
                        <a 
                            href="https://apps.apple.com/us/app/futeurcred/id6736497241" 
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-6 py-3 bg-black text-white font-medium rounded-md hover:bg-gray-900 transition-all duration-300 ease-in-out shadow-md border border-gray-700"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 384 512" fill="currentColor">
                                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                            </svg>
                            Available on App Store
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

